<template>
  <div style="height: calc(100% - 150px)">
    <WorkspaceChatHeader
      @update:ticket="$emit('update:ticket')"
      :isChat="false"
      :inCall="showWebphone"
    />
    <WorkspaceCallCard
      v-if="showWebphone"
      @open-overlay="$emit('open-overlay')"
      @minimize-overlay="$emit('minimize-overlay')"
    />
    <WorkspaceVoiceCard v-else />

    <div v-if="isManagedByBeexai" class="beexai-managed">
      <span class="beexai-managed__text">Gestionado por BeexAI</span>
      <img :src="BeexIA" width="14" height="14" alt="beexai-icon" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import WorkspaceChatHeader from "@/app/workspace/components/chat/WorkspaceChatHeader.vue";
import WorkspaceCallCard from "@/app/workspace/components/cards/WorkspaceCallCard.vue";
import WorkspaceVoiceCard from "@/app/workspace/components/cards/WorkspaceVoiceCard.vue";
import { CallStatus } from "@/packages/vue-jssip/jssip/phone";
import { ChannelType, EventManagement } from "@/app/shared/utils/enums";

import { registerEventManagement } from "@/app/shared/services";
import { safeRegisterEventManagement } from "@/app/shared/composables/useRegisterEventManagement";
import BeexIA from "@/app/common/assets/beexia.svg?url";

export default defineComponent({
  components: {
    WorkspaceCallCard,
    WorkspaceVoiceCard,
    WorkspaceChatHeader,
  },
  props: {
    ticket: Object,
  },
  data() {
    return { BeexIA };
  },
  computed: {
    isCurrentTicket() {
      const ticketId = this.$route.query?.ticket;
      const interactionId = this.$route.query?.interaction;

      return this.$jssip.phone.isCurrentCallTicketInteraction(ticketId, interactionId);
    },
    isInAcw() {
      return this.$store.getters["getStateUser"] === EventManagement.Acw;
    },
    showWebphone() {
      return this.isInACall && this.isCurrentTicket && !this.isInAcw;
    },
    interactionId() {
      return this.$route.query?.interaction;
    },
    ticketId() {
      return this.$route.query?.ticket;
    },
    isInACall() {
      return (
        this.$jssip.phone.status == CallStatus.Connecting ||
        this.$jssip.phone.status == CallStatus.Ringing ||
        this.$jssip.phone.status == CallStatus.InCall
      );
    },
    dataUserState() {
      return this.$store.getters["getDataUserState"];
    },
    dialingType() {
      return this.$store.getters["getDialingType"];
    },
    globalState() {
      return this.$store.getters["getStateUser"];
    },
    ticketSelected() {
      return this.ticket;
    },
    // Ticket atendido por un Agente IA de BeexAI (tag permanente "Agente IA")
    isManagedByBeexai() {
      return this.ticket?.tags?.some((tag) => tag.name === "Agente IA" && tag.is_permanent);
    },
  },
  methods: {
    async registerEventOnline() {
      await safeRegisterEventManagement(EventManagement.Online, {
        call_ticket: this.$jssip.phone?.meta?.ticket,
        type_dialing: this.dialingType,
        menu: 23,
        state: this.dataUserState,
        module: 'workspace-call-section',
      });
    }
  },
});
</script>

<style lang="sass" scoped>
.beexai-managed
  display: flex
  align-items: center
  justify-content: flex-end
  gap: 6px
  // El boton de rellamar del webphone es absolute y sobresale bajo su footer
  margin-top: 36px
  padding: 6px 16px
  font-size: 12px

  &__text
    background: linear-gradient(222.89deg, #FF1FB5 7.52%, #9C4DFF 52.95%, #602CD8 98.38%)
    -webkit-background-clip: text
    background-clip: text
    -webkit-text-fill-color: transparent
</style>
